// extracted by mini-css-extract-plugin
export default {"root":"App_root__G1SHT","browserupgrade":"App_browserupgrade__nc1xQ","app":"App_app__TVqnn","embedWarning":"App_embedWarning__p+NNA","appImage":"App_appImage__GPnKf"};